import React from "react";
import styled from "styled-components/macro";
import type { IconDefinition } from "@fortawesome/fontawesome-common-types";
import GradientFAIcon from "icons/GradientFAIcon";

const IconWrapper = styled.div<{ $size: "large" | "default" | "medium" }>`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ebfaf2;
  flex-shrink: 0;

  ${({ $size }) => {
    switch ($size) {
      case "large":
        return `
          width: 80px;
          height: 80px;
        `;
      case "medium":
        return `
          width: 40px;
          height: 40px;
        `;
      case "default":
      default:
        return `
          width: 70px;
          height: 70px;
        `;
    }
  }}
`;

type PracticeIconProps = {
  icon: IconDefinition;
  size?: "large" | "default" | "medium";
};

export const PracticeIcon: React.FC<PracticeIconProps> = ({ icon, size = "default" }) => {
  const iconPx = size === "large" ? 42 : size === "medium" ? 16 : 36;
  return (
    <IconWrapper $size={size}>
      <GradientFAIcon icon={icon} size={iconPx} angle={180} colors={["#3CD175", "#2CA48C"]} />
    </IconWrapper>
  );
};
